import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance.js";
import { BASE_URL } from "../../config.js";
import "./Fuel.css";

export default function Fuel() {
  const token = JSON.parse(localStorage.getItem("NagpurProperties"))?.token;
  const [GetMachineName, setGetMachinename] = useState([]);
  const [SelectedMachine, setSelectedMachine] = useState("");
  const [FuelData, setFuelData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [AverageData, setAverageData] = useState(null);
  const [showAveragePopup, setShowAveragePopup] = useState(false);

  useEffect(() => {
    async function getAllMachineName() {
      try {
        const response = await axiosInstance.get(
          `${BASE_URL}/machines/singleMechine`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setGetMachinename(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    getAllMachineName();
  }, [token]);

  // Effect to fetch fuel data whenever a new machine is selected.
  useEffect(() => {
    async function fetchFuelData() {
      if (!SelectedMachine) {
        setFuelData([]);
        return;
      }
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          `${BASE_URL}/logs/${SelectedMachine}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setFuelData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    }
    fetchFuelData();
  }, [SelectedMachine, token]);

  async function handleCheckAverage(fuelId) {
    setShowAveragePopup(true);
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/average/history/${fuelId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);
      setAverageData(response.data);
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <>
      <div className="fuel-container">
        <div className="fuel-card">
          {/* <div className="fuel-header">
            <h1 className="fuel-heading">Fuel Management</h1>
          </div> */}

          {/* <div className="fuel-header">
            <div className="fuel-header-bg">
              <div className="fuel-animated-shape fuel-shape-1"></div>
              <div className="fuel-animated-shape fuel-shape-2"></div>
              <div className="fuel-animated-shape fuel-shape-3"></div>
              <div className="fuel-animated-shape fuel-shape-4"></div>
            </div>
            <div className="fuel-header-content">
              <h1 className="fuel-title">Fuel Management</h1>
              <p className="fuel-subtitle">
                Real-time insights for informed decision-making
              </p>
            </div>
          </div> */}

          <div className="fuel-content">
            <div className="fuel-select-wrapper">
              <label htmlFor="machine-select" className="fuel-label">
                Select a Machine
              </label>
              <div className="fuel-custom-select">
                <select
                  id="machine-select"
                  value={SelectedMachine}
                  onChange={(e) => setSelectedMachine(e.target.value)}
                  className="fuel-select"
                >
                  <option value="">Select Machine</option>
                  {GetMachineName.map((machine) => (
                    <option key={machine.id} value={machine.id}>
                      {machine.machineName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {isLoading ? (
              <div className="fuel-loading">
                <p>Loading fuel data...</p>
              </div>
            ) : FuelData.length > 0 ? (
              <div className="fuel-table-responsive">
                <table className="fuel-table">
                  <thead>
                    <tr>
                      <th>Machine Name</th>
                      <th>Driver Name</th>
                      <th>Odometer</th>
                      <th>Fuel (L)</th>
                      <th>Price/L</th>
                      <th>Total Price</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {FuelData.map((fuel) => {
                      const fullDateTime = new Date(
                        `${fuel.date}T${fuel.time}`
                      );
                      return (
                        <tr key={fuel.id}>
                          <td>{fuel.machineName}</td>
                          <td>{fuel.driverName}</td>
                          <td>{fuel.odometerReading}</td>
                          <td>{fuel.fuelFilled}</td>
                          <td>₹{fuel.pricePerLiter}</td>
                          <td>₹{fuel.totalPrice}</td>
                          <td>{fullDateTime.toLocaleDateString()}</td>
                          <td>
                            {fullDateTime.toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}
                          </td>
                          <td>
                            <button
                              className="check_average_btn"
                              onClick={() => handleCheckAverage(fuel.id)}
                            >
                              Check average
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="fuel-no-data">
                <p>No fuel data available for the selected machine.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {showAveragePopup && AverageData && (
        <div className="fuel-popup-overlay">
          <div className="fuel-popup-card">
            <h3>Fuel Average History</h3>
            <div className="fuel-table-wrapper">
              <table className="fuel-average-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Distance</th>
                    <th>Fuel Used</th>
                    <th>Mileage</th>
                  </tr>
                </thead>
                <tbody>
                  {AverageData.map((item, index) => {
                    const fullDateTime = new Date(`${item.date}T${item.time}`);
                    return (
                      <tr key={index}>
                        <td>{fullDateTime.toLocaleDateString()}</td>
                        <td>
                          {fullDateTime.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </td>
                        <td>{item.distanceTravelled} km</td>
                        <td>{item.fuelUsed} L</td>
                        <td>{item.mileage.toFixed(2)} km/L</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <button
              className="fuel-popup-close-btn"
              onClick={() => setShowAveragePopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
